export default __webpack_public_path__ + "static/media/sun.14fc11bb.svg";